
import {getRezyme} from '../api/getRezyme';
import {setGetRezymeAction} from '../action';
import { setLoadingAction } from '../../../components/templatePage/store/action';

const setGetRezyme = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getRezyme(params);

            if (data.status === 'success') {
                const rezyme = [...getState().usersMobile.rezyme.data];
                rezyme.push(data.data);
                dispatch(setGetRezymeAction({
                    data: rezyme.flat(1),
                    countPage: data.count
                }));  
                dispatch(setLoadingAction(false))         
            }
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetRezyme
}